import React from "react";
import Footer from "../footer/Footer";
import {
  Grid,
  OutlinedInput,
  TextField,
  InputLabel,
  Container,
  MenuItem,
} from "@material-ui/core";
import { useStyles } from "./DemoForm.module";
import DemoFormLogic from "./DemoForm.logic";
import MFAButton from "../shared/button/buttonMFA/buttonMFA";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertMessage from "../shared/alert/alert";
import Tooltip from "@material-ui/core/Tooltip";

export default function DemoForm(props) {
  const classes = useStyles();

  const {
    translator,
    values,
    errors,
    handleChange,
    handleContact,
    handleSubmit,
    canContact,
    canSubmit,
    loadingContact,
    loadingSubmit,
    formSubmitted,
    alert,
  } = DemoFormLogic(props);

  return (
    <>
      <Container maxWidth="lg" className={classes.root}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <h2 className={classes.title}>{translator("demoForm.title")}</h2>
            <p className={classes.instructionText}>
              {translator("demoForm.instructionText")}
            </p>

            <form className={classes.form} noValidate>
              <Grid item xs={12} align="left">
                <InputLabel
                  className={classes.labels}
                  style={{ marginBottom: 3.5 }}
                >
                  {translator("demoForm.ownsAssetOrProject")}*
                </InputLabel>
                <TextField
                  select
                  name="ownsAsset"
                  className={classes.formDemoSelect}
                  variant="outlined"
                  fullWidth
                  required
                  value={values.ownsAsset}
                  onChange={handleChange}
                >
                  <MenuItem className={classes.menuDemoForm} value="" disabled>
                    {translator("common.select")}
                  </MenuItem>
                  <MenuItem className={classes.menuDemoForm} value="yes">
                    {translator("common.yes")}
                  </MenuItem>
                  <MenuItem className={classes.menuDemoForm} value="no">
                    {translator("common.no")}
                  </MenuItem>
                </TextField>
                {errors.error_ownsAsset && (
                  <span className={classes.errorText}>
                    {errors.error_ownsAsset}
                  </span>
                )}
              </Grid>

              {values.ownsAsset === "no" && (
                <>
                  <Grid
                    container
                    spacing={2}
                    className={classes.shortFieldContainer}
                  >
                    <Grid item xs={12} md={6} align="left">
                      <label className={classes.labels}>
                        {translator("demoForm.mail")}*
                      </label>
                      <OutlinedInput
                        className={classes.textField}
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                      />
                      {errors.error_email && (
                        <span className={classes.errorText}>
                          {errors.error_email}
                        </span>
                      )}
                    </Grid>
                    <Grid item xs={12} md={6} align="left">
                      <label className={classes.labels}>
                        {translator("demoForm.phoneNumber")}
                      </label>
                      <OutlinedInput
                        className={classes.textField}
                        name="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors.error_phoneNumber && (
                        <span className={classes.errorText}>
                          {errors.error_phoneNumber}
                        </span>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}

              {values.ownsAsset === "yes" && (
                <>
                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.companyName")}*
                    </label>
                    <OutlinedInput
                      className={classes.textField}
                      name="companyName"
                      value={values.companyName}
                      onChange={handleChange}
                    />
                    {errors.error_companyName && (
                      <span className={classes.errorText}>
                        {errors.error_companyName}
                      </span>
                    )}
                  </Grid>

                  <Grid
                    container
                    spacing={2}
                    className={classes.shortFieldContainer}
                  >
                    <Grid item xs={12} md={6} align="left">
                      <label className={classes.labels}>
                        {translator("demoForm.mail")}*
                      </label>
                      <OutlinedInput
                        className={classes.textField}
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                      />
                      {errors.error_email && (
                        <span className={classes.errorText}>
                          {errors.error_email}
                        </span>
                      )}
                    </Grid>
                    <Grid item xs={12} md={6} align="left">
                      <label className={classes.labels}>
                        {translator("demoForm.phoneNumber")}*
                      </label>
                      <OutlinedInput
                        className={classes.textField}
                        name="phoneNumber"
                        value={values.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors.error_phoneNumber && (
                        <span className={classes.errorText}>
                          {errors.error_phoneNumber}
                        </span>
                      )}
                    </Grid>
                  </Grid>

                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.assetOrProjectName")}*
                    </label>
                    <OutlinedInput
                      className={classes.textField}
                      name="assetProjectName"
                      value={values.assetProjectName}
                      onChange={handleChange}
                    />
                    {errors.error_assetProjectName && (
                      <span className={classes.errorText}>
                        {errors.error_assetProjectName}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.locationCountryRegion")}*
                    </label>
                    <OutlinedInput
                      className={classes.textField}
                      name="location"
                      value={values.location}
                      onChange={handleChange}
                    />
                    {errors.error_location && (
                      <span className={classes.errorText}>
                        {errors.error_location}
                      </span>
                    )}
                  </Grid>

                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.gpsCoordinates")}*
                    </label>
                    <OutlinedInput
                      className={classes.textField}
                      name="gps"
                      value={values.gps}
                      onChange={handleChange}
                      placeholder="ej: 18.98155147356452, -98.2612402969816"
                    />
                    {errors.error_gps && (
                      <span className={classes.errorText}>{errors.error_gps}</span>
                    )}
                  </Grid>

                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.quantityOrUnit")}*
                    </label>
                    <TextField
                      select
                      name="quantityUnit"
                      className={classes.formDemoSelect}
                      variant="outlined"
                      fullWidth
                      required
                      value={values.quantityUnit}
                      onChange={handleChange}
                    >
                      <MenuItem className={classes.menuDemoForm} value="" disabled>
                        {translator("common.select")}
                      </MenuItem>
                      <MenuItem className={classes.menuDemoForm} value="hectare">
                        {translator("demoForm.hectare")}
                      </MenuItem>
                      <MenuItem className={classes.menuDemoForm} value="acre">
                        {translator("demoForm.acre")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="square_meter"
                      >
                        {translator("demoForm.square")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="cubic_meter"
                      >
                        {translator("demoForm.cubic")}
                      </MenuItem>
                      <MenuItem className={classes.menuDemoForm} value="ton">
                        {translator("demoForm.ton")}
                      </MenuItem>
                      <MenuItem className={classes.menuDemoForm} value="other">
                        {translator("demoForm.other")}
                      </MenuItem>
                    </TextField>
                    {errors.error_quantityUnit && (
                      <span className={classes.errorText}>
                        {errors.error_quantityUnit}
                      </span>
                    )}
                  </Grid>
                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.projectType")}*
                    </label>
                    <TextField
                      select
                      name="project_type"
                      className={classes.formDemoSelect}
                      variant="outlined"
                      fullWidth
                      required
                      value={values.project_type}
                      onChange={handleChange}
                    >
                      <MenuItem className={classes.menuDemoForm} value="" disabled>
                        {translator("common.select")}
                      </MenuItem>
                      <MenuItem className={classes.menuDemoForm} value="syntropic">
                        {translator("demoForm.project_syntropic")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="conservation"
                      >
                        {translator("demoForm.project_conservation")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="reforestation"
                      >
                        {translator("demoForm.project_reforestation")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="biodevirsity_and_ecosystem_management"
                      >
                        {translator(
                          "demoForm.project_biodevirsity_and_ecosystem_management"
                        )}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="agroforestry"
                      >
                        {translator("demoForm.project_agroforestry")}
                      </MenuItem>
                      <MenuItem
                        className={classes.menuDemoForm}
                        value="other"
                      >
                        {translator("demoForm.other")}
                      </MenuItem>
                    </TextField>
                    {errors.error_project_type && (
                      <span className={classes.errorText}>
                        {errors.error_project_type}
                      </span>
                    )}
                  </Grid>

                  {values.project_type === "other" && (
                    <Grid item xs={12} align="left">
                      <label className={classes.labels}>
                        {translator("demoForm.projectTypeOther")}*
                      </label>
                      <OutlinedInput
                        className={classes.textField}
                        name="project_type_other"
                        value={values.project_type_other}
                        onChange={handleChange}
                      />
                      {errors.error_project_type_other && (
                        <span className={classes.errorText}>
                          {errors.error_project_type_other}
                        </span>
                      )}
                    </Grid>
                  )}

                  <Grid item xs={12} align="left">
                    <label className={classes.labels}>
                      {translator("demoForm.openEnded")}*
                    </label>
                    <TextField
                      variant="outlined"
                      className={classes.textArea}
                      name="openEnded"
                      value={values.openEnded}
                      onChange={handleChange}
                      multiline
                      rows={4}
                    />
                    {errors.error_openEnded && (
                      <p className={classes.errorText}>{errors.error_openEnded}</p>
                    )}
                  </Grid>
                </>
              )}

              {values.ownsAsset === "no" && (
                <Grid item xs={12} align="left">
                  <Tooltip
                    title={
                      !canContact ? translator("demoForm.tooltipAddEmail") : ""
                    }
                    arrow
                    placement="top"
                    classes={{
                      tooltip: classes.customTooltip,
                      arrow: classes.customArrow,
                    }}
                  >
                    <span style={{ display: "block", width: "100%" }}>
                      <MFAButton
                        mode="normal"
                        type="DisabledWhiteborderblue"
                        disabled={!canContact || loadingSubmit || formSubmitted}
                        onClick={handleContact}
                        style={{ width: "100%" }}
                        text={
                          loadingContact ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CircularProgress
                                size={18}
                                color="inherit"
                                style={{ marginRight: 8 }}
                              />
                              {translator("demoForm.contactEGreen")}
                            </span>
                          ) : (
                            translator("demoForm.contactEGreen")
                          )
                        }
                      />
                    </span>
                  </Tooltip>
                </Grid>
              )}

              {values.ownsAsset === "yes" && (
                <Grid item xs={12} align="left">
                  <Tooltip
                    title={
                      !canSubmit
                        ? translator("demoForm.tooltipCompleteForm")
                        : ""
                    }
                    arrow
                    placement="top"
                    classes={{
                      tooltip: classes.customTooltip,
                      arrow: classes.customArrow,
                    }}
                  >
                    <span style={{ display: "block", width: "100%" }}>
                      <MFAButton
                        mode="normal"
                        type="DisabledWhiteborderblue"
                        disabled={!canSubmit || loadingContact}
                        onClick={handleSubmit}
                        style={{ width: "100%" }}
                        text={
                          loadingSubmit ? (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CircularProgress
                                size={18}
                                color="inherit"
                                style={{ marginRight: 8 }}
                              />
                              {translator("demoForm.FormButton")}
                            </span>
                          ) : (
                            translator("demoForm.FormButton")
                          )
                        }
                      />
                    </span>
                  </Tooltip>
                </Grid>
              )}
              {alert && (
                <div style={{ marginTop: 16 }}>
                  <AlertMessage
                    type={alert.type}
                    textKey={alert.key}
                    text={alert.text}
                  />
                </div>
              )}
            </form>

            <p className={classes.privacyInfo}>
              {translator("demoForm.PrivacyAlert")}
            </p>
          </Grid>

          <Grid item xs={12} md={6} className={classes.imageContainer}>
            <p className={classes.imgText}>{translator("demoForm.imgText")}</p>
          </Grid>
        </Grid>
      </Container>

      <Footer />
    </>
  );
}
